{
  "clearThisNote": "Clear this note?",
  "deviceComment": "Comment",
  "leaveANote": "Leave a Note",
  "newDeviceComment": "New Device Comment",
  "thisCommentWillBeVisibleToAllOtherUsersAssociatedWithYourFarmAccount": "This comment will be visible to all other users associated with your farm account."
}
